/**
 * Display columns of plain text, as a monospace chord chart lays it out.
 *
 * Chord charts align a chord over a lyric by column. CJK characters take two
 * columns in a monospace font, combining marks none, and astral characters
 * are two UTF-16 code units, so columns are counted per code point with East
 * Asian wide forms counted twice and combining marks not at all.
 */
/**
 * Columns a character occupies: 0 for combining marks that sit on the previous
 * letter (Devanagari vowel signs, Arabic harakat), 2 for CJK and fullwidth
 * forms, else 1.
 */
export const charWidth = (ch) => {
    if (/[\p{Mn}\p{Me}]/u.test(ch))
        return 0;
    const cp = ch.codePointAt(0) ?? 0;
    const wide = (cp >= 0x1100 && cp <= 0x115f) || // Hangul Jamo
        (cp >= 0x2e80 && cp <= 0xa4cf && cp !== 0x303f) || // CJK radicals … Yi, incl. kana and ideographic space
        (cp >= 0xac00 && cp <= 0xd7a3) || // Hangul syllables
        (cp >= 0xf900 && cp <= 0xfaff) || // CJK compatibility ideographs
        (cp >= 0xfe30 && cp <= 0xfe4f) || // CJK compatibility forms
        (cp >= 0xff00 && cp <= 0xff60) || // Fullwidth forms
        (cp >= 0xffe0 && cp <= 0xffe6) ||
        (cp >= 0x20000 && cp <= 0x3fffd); // CJK extensions
    return wide ? 2 : 1;
};
/** Display width of a string. */
export const displayWidth = (text) => {
    let width = 0;
    for (const ch of text)
        width += charWidth(ch);
    return width;
};
